import React from 'react';
import { VitalChartSC } from './vital-chart.styled';
import VitalChartDot from './vital-chart-dot';

const VitalChartEmpty: React.FC = () => {
  return (
    <VitalChartSC color="#EAEBF0">
      <img src={require('../../../../assets/png/vital-chart-empty.png').default} alt="" />
      <div className="vc-data">
        <span className="vc-empty-label">--</span>
      </div>
      <VitalChartDot color={'#EAEBF0'} degree={180} />
    </VitalChartSC>
  );
};

export default React.memo(VitalChartEmpty);
